import {
    MemberCombo as BaseMemberCombo,
    MemberComboCheck as BaseMemberComboCheck,
    MemberComboProps,
    MemberComboCheckProps
} from '@fx-ui/jdy-design-biz';
import React from 'react';
import MemberName from '../member-name';

export const MemberCombo: React.FC<MemberComboProps> = (props) => {
    return (
        <BaseMemberCombo
            nameRender={(member, keyword) => {
                return <MemberName name={member.nickname} keyword={keyword} />;
            }}
            {...props}
        />
    );
};

export const MemberComboCheck: React.FC<MemberComboCheckProps> = (props) => {
    return (
        <BaseMemberComboCheck
            nameRender={(member, keyword) => {
                return <MemberName name={member.nickname} keyword={keyword} />;
            }}
            {...props}
        />
    );
};
